export const queueAgentStatus = Object.freeze({
  AVAILABLE: 'AVAILABLE',
  RING: 'RING',
  RINGING: 'RINGING',
  PAUSE: 'PAUSE',
  UNPLACED: 'UNPLACED',
  TABULATION_PAUSE: 'TABULATION_PAUSE',
  OFFLINE: 'OFFLINE'
});
